<template>
  <div class="project-settings-general">
    <Section>
      <div class="section-body">
        <div class="row">
          <div class="col-lg-9">
            <div class="list-container">
              <div class="list-group">
                <label>Project name</label>
                <div class="list-item" v-if="!state.isEditing">
                  {{project.title}}
                  <button type="button" class="btn btn-link btn-sm" @click="state.isEditing = true">
                    Change
                  </button>
                </div>
                <div class="list-item" v-if="state.isEditing">
                  <ProjectEditTitle
                    :value="project.title"
                    :state="state"
                    :onSubmit="onEditProject" />
                </div>
              </div>
              <div class="list-group">
                <label>Project ID</label>
                <div class="list-item">{{project.projectId}}</div>
                <span class="help-text">
                  * ชื่อ ID ของโปรเจคต์จะถูกใช้เพื่อเป็น referer
                  ในการรับส่งข้อมูลสถิติระหว่างแอพพลิเคชั่นของท่านกับ Lighthouse
                </span>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="meta-container">
              <div class="meta-group">
                <label><i class="far fa-clock"></i> Last updated : {{ formatDateTime(project.updatedAt) }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  </div>
</template>

<script>

import dateFormatter from '@/utils/dateFormatter';
import { editProject } from '@/project/api';
import Section from '@/components/Section.vue';
import ProjectEditTitle from '@/project/ProjectEditTitle.vue';

export default {
  mixins: [dateFormatter],
  props: {
    project: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    Section,
    ProjectEditTitle,
  },
  data() {
    return {
      state: {
        isSaving: false,
        isEditing: false,
        error: null,
      },
    };
  },
  computed: {
    teamName() {
      return this.$route.params.teamName;
    },
    projectId() {
      return this.$route.params.projectId;
    },
  },
  methods: {
    async onEditProject(value) {
      try {
        const payload = { ...this.project, title: value };
        const response = await editProject(this.projectId, payload);
        this.$store.dispatch('updateProject', response.data);
        this.state.isLoading = false;
        this.state.isEditing = false;
      } catch (error) {
        this.state.error = error.response;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/list.scss';

.meta-container {
  .meta-group {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    label {
      font-size: $font-size-sm;
      margin-bottom: $spacer * 0.25;
      color: $gray-500;
    }
  }
}

@media (max-width: 991.98px) {
  .meta-container {
    padding-top: $spacer * 1.5;
    .meta-group {
      align-items: flex-start;
    }
  }
}

</style>
